import {
  ArcElement,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Tooltip,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

/**
 * Register every ChartJS element the dashboard charts use — once. Every chart
 * imports `DASHBOARD_CHART_BASE_OPTIONS` (or an axis util, which imports this
 * module) from here, so importing any chart runs this side effect exactly once
 * instead of repeating `ChartJS.register(...)` per chart file.
 */
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  ArcElement,
  Tooltip,
  Legend,
  ChartDataLabels,
);

/** Shared options for every dashboard chart (fills the card, no fixed aspect ratio). */
export const DASHBOARD_CHART_BASE_OPTIONS = {
  responsive: true,
  maintainAspectRatio: false,
};

/** Axis-title font sized for the compact dashboard cards (smaller than the reports drawer's). */
export const AXIS_TITLE_FONT = { size: 12, weight: 600 };

export const AXIS_TICK_FONT_SIZE = 11;
